import { combineReducers } from 'redux';
import { liveInputFormReducer } from 'state/secondaryMarket/live/form/input/inputForm.reducer';
import { liveOriginalFormReducer } from 'state/secondaryMarket/live/form/original/liveOriginalForm.reducer';

import type { SecondaryMarketLiveFormData } from './liveForm.model';

export const liveFormReducer = combineReducers<SecondaryMarketLiveFormData>({
  input: liveInputFormReducer,
  original: liveOriginalFormReducer,
});
